import React from 'react';
import { observer, inject } from 'mobx-react';

import InputField from '~/common/components/InputField';

// Import Stylesheet
import styles from './account-info.css';

@inject('formsStore', 'contentStore', 'checkoutStore')
@observer
export default class AccountInfo extends React.Component {

    render() {
        const { formsStore } = this.props;
        const { upgradeUrl } = this.props.checkoutStore;
        const { labelContent } = this.props.contentStore;
        const {
            FirstName,
            FirstNameError,
            FirstNameValid,
            LastName,
            LastNameError,
            LastNameValid,
            Email,
            EmailError,
            EmailValid,
            Password,
            PasswordError,
            PasswordValid
        } = formsStore;
        const disabled = false;
        const handleLoginClick = () => {
            window.preventFormAbandonmentTracking = true; 
            window.location.replace(upgradeUrl); 
            window.location.reload();
        };

        return (
            <div className="account-info">
                <h2>
                    { labelContent.CreateAnAccount } <a onClick={handleLoginClick}>{ ` ${labelContent.SignIn}` }</a>
                </h2>
                <div className={styles.grid}>
                    <InputField
                        allowedCharacters="@.!#$%&'*+-/=?^_`{|}~"
                        autofill="email"
                        defaultValue={Email}
                        disabled={!!disabled}
                        error={EmailError}
                        focus={true}
                        id="login__email"
                        label={ labelContent.Email }
                        name="Email"
                        onBlur={() => formsStore.EmailValidation()}
                        restrictCharacters="alphaNumericOnly"
                        type="email"
                        valid={EmailValid}
                        wrapperClass={styles.email}
                    />
                    <InputField
                        allowedCharacters=" -'"
                        autofill="given-name"
                        defaultValue={FirstName}
                        disabled={!!disabled}
                        error={FirstNameError}
                        id="first-name"
                        label={labelContent.FirstName}
                        maxLength={50}
                        name="FirstName"
                        onBlur={() => formsStore.FirstNameValidation()}
                        restrictCharacters="latinOnly"
                        type="text"
                        valid={FirstNameValid}
                        wrapperClass={styles['first-name']}
                    />
                    <InputField
                        allowedCharacters="-'"
                        autofill="family-name"
                        defaultValue={LastName}
                        disabled={!!disabled}
                        error={LastNameError}
                        id="last-name"
                        label={labelContent.LastName}
                        maxLength={50}
                        name="LastName"
                        onBlur={() => formsStore.LastNameValidation()}
                        restrictCharacters="latinOnly"
                        type="text"
                        valid={LastNameValid}
                        wrapperClass={styles['last-name']}
                    />
                    <InputField
                        allowedCharacters="@.!#$%&'*+-/=?^_`{|}~"
                        autofill="email"
                        defaultValue={Password}
                        error={PasswordError}
                        id="login__password"
                        label={labelContent.Password}
                        labelContent={labelContent}
                        name="Password"
                        onChange={() => this.props.formsStore.PasswordValidation()}
                        password={true}
                        passwordFocus={this.props.formsStore.PasswordFocus}
                        requirement1={this.props.formsStore.Requirement1}
                        requirement2={this.props.formsStore.Requirement2}
                        requirement3={this.props.formsStore.Requirement3}
                        restrictCharacters="alphaNumericOnly"
                        type="password"
                        valid={PasswordValid}
                    />
                </div>
            </div>
        );
    }
}
